import dynamic from "next/dynamic";
import type { ParagraphData } from "@/lib/api/cms-catalog";
import {
  PARAGRAPH_TEXT_LAYOUT,
  PARAGRAPH_TEXT_IMAGES_LEFT_LAYOUT,
  PARAGRAPH_TEXT_IMAGES_RIGHT_LAYOUT,
  PARAGRAPH_TEXT_IMAGES_TOP_LAYOUT,
  PARAGRAPH_TEXT_IMAGES_BOT_LAYOUT,
  PARAGRAPH_TWO_COLS_TEXT_LAYOUT,
  PARAGRAPH_TWO_COLS_TEXT_VIDEO_LAYOUT,
  PARAGRAPH_TWO_COLS_TABLE_TEXT_LAYOUT,
  PARAGRAPH_TWO_COLS_TEXT_GALLERY_LAYOUT,
  PARAGRAPH_PREZENTATION_LAYOUT,
  PARAGRAPH_BIG_PHOTO_LAYOUT,
  PARAGRAPH_THREE_COLS_TEXT_LAYOUT,
  PARAGRAPH_THREE_COLS_TEXT_TEXT_PHOTO_LAYOUT,
  PARAGRAPH_THREE_COLS_TEXT_PHOTO_TEXT_LAYOUT,
  PARAGRAPH_THREE_COLS_PHOTO_TEXT_TEXT_LAYOUT,
  PARAGRAPH_THREE_COLS_BIG_VIDEO_LAYOUT,
  PARAGRAPH_TWO_BOXES_LAYOUT,
  PARAGRAPH_THREE_BOXES_LAYOUT,
  PARAGRAPH_CONTACT_FORM_LAYOUT,
  PARAGRAPH_MAPS_LAYOUT,
  PARAGRAPH_TWO_COLS_TEXT_PREZENTATION_LAYOUT,
  PARAGRAPH_BLOG_POSTS_LAYOUT,
  PARAGRAPH_CONTACT_PERSON_LAYOUT,
  PARAGRAPH_HERO_CTA_LAYOUT,
  PARAGRAPH_PROCESS_STEPS_LAYOUT,
  PARAGRAPH_CTA_BANNER_LAYOUT,
  PARAGRAPH_PRODUCT_CTA_LAYOUT,
  PARAGRAPH_FEATURES_ICONS_LAYOUT,
  PARAGRAPH_TEXT_STATS_LAYOUT,
  PARAGRAPH_TECH_STACK_LAYOUT,
  PARAGRAPH_SERVICE_HERO_LAYOUT,
  PARAGRAPH_WHY_US_LAYOUT,
  PARAGRAPH_FEATURES_2COL_LAYOUT,
  PARAGRAPH_PRICING_TIERS_LAYOUT,
  PARAGRAPH_INTEGRATIONS_GRID_LAYOUT,
  PARAGRAPH_TWO_PATHS_LAYOUT,
  PARAGRAPH_DARK_FEATURES_LAYOUT,
  PARAGRAPH_SERVICES_LAYOUT,
  PARAGRAPH_TEXT_MINI_CARDS_LAYOUT,
  PARAGRAPH_DARK_HERO_CTA_LAYOUT,
  PARAGRAPH_FEATURES_4COL_LAYOUT,
  PARAGRAPH_GALLERY_SLIDER_LAYOUT,
  PARAGRAPH_HERO_PRODUCT_LAYOUT,
  PARAGRAPH_DARK_TEXT_MINI_CARDS_LAYOUT,
  PARAGRAPH_LIGHT_FEATURES_2X2_LAYOUT,
  PARAGRAPH_TEAL_SPLIT_CTA_LAYOUT,
  PARAGRAPH_PRODUCT_VARIANTS_SELECTOR_LAYOUT,
  PARAGRAPH_CLIENT_LOGOS_LAYOUT,
  PARAGRAPH_SPLIT_TEXT_STICKY_CTA_LAYOUT,
  PARAGRAPH_AUDIENCE_MATCH_LAYOUT,
  PARAGRAPH_STORY_CARD_LAYOUT,
  PARAGRAPH_LIGHT_CTA_BANNER_LAYOUT,
  PARAGRAPH_TIMELINE_STEPS_LAYOUT,
  PARAGRAPH_TWO_MODELS_COMPARE_LAYOUT,
  PARAGRAPH_INFO_NOTICE_LAYOUT,
  PARAGRAPH_METRICS_CHECKLIST_IMAGE_LAYOUT,
  PARAGRAPH_BENEFITS_TOOLS_LAYOUT,
  PARAGRAPH_REALIZATIONS_TESTIMONIALS_LAYOUT,
  PARAGRAPH_FAQ_LAYOUT,
  PARAGRAPH_BLOG_LATEST_LAYOUT,
  PARAGRAPH_RELATED_CATALOGS_LAYOUT,
  PARAGRAPH_ANNOUNCEMENT_BAR_LAYOUT,
  PARAGRAPH_DARK_HERO_BACK_LAYOUT,
} from "@/lib/cms/paragraphLayouts";
import type { ParagraphTranslations } from "./Paragraph.i18n";
import { ParagraphText } from "./layouts/ParagraphText";
import { ParagraphTextImages } from "./layouts/ParagraphTextImages";
import { ParagraphTwoColsText } from "./layouts/ParagraphTwoColsText";
import { ParagraphTwoColsTextVideo } from "./layouts/ParagraphTwoColsTextVideo";
import { ParagraphTwoColsTableText } from "./layouts/ParagraphTwoColsTableText";
import { ParagraphBigPhoto } from "./layouts/ParagraphBigPhoto";
import { ParagraphThreeColsText } from "./layouts/ParagraphThreeColsText";
import { ParagraphThreeColsTextImages } from "./layouts/ParagraphThreeColsTextImages";
import { ParagraphBigVideo } from "./layouts/ParagraphBigVideo";
import { ParagraphTwoBoxes } from "./layouts/ParagraphTwoBoxes";
import { ParagraphThreeBoxes } from "./layouts/ParagraphThreeBoxes";
import { ParagraphContactForm } from "./layouts/ParagraphContactForm";
import { ParagraphMaps } from "./layouts/ParagraphMaps";
import { ParagraphBlogPosts } from "./layouts/ParagraphBlogPosts";
import { ParagraphContactPerson } from "./layouts/ParagraphContactPerson";
import { ParagraphHeroCta } from "./layouts/ParagraphHeroCta";
import { ParagraphProcessSteps } from "./layouts/ParagraphProcessSteps";
import { ParagraphCtaBanner } from "./layouts/ParagraphCtaBanner";
import { ParagraphProductCta } from "./layouts/ParagraphProductCta";
import { ParagraphFeaturesIcons } from "./layouts/ParagraphFeaturesIcons";
import { ParagraphTextStats } from "./layouts/ParagraphTextStats";
import { ParagraphTechStack } from "./layouts/ParagraphTechStack";
import { ParagraphServiceHero } from "./layouts/ParagraphServiceHero";
import { ParagraphWhyUs } from "./layouts/ParagraphWhyUs";
import { ParagraphFeatures2Col } from "./layouts/ParagraphFeatures2Col";
import { ParagraphPricingTiers } from "./layouts/ParagraphPricingTiers";
import { ParagraphIntegrationsGrid } from "./layouts/ParagraphIntegrationsGrid";
import { ParagraphTwoPaths } from "./layouts/ParagraphTwoPaths";
import { ParagraphDarkFeatures } from "./layouts/ParagraphDarkFeatures";
import { ParagraphServices } from "./layouts/ParagraphServices";
import { ParagraphTextMiniCards } from "./layouts/ParagraphTextMiniCards";
import { ParagraphDarkHeroCta } from "./layouts/ParagraphDarkHeroCta";
import { ParagraphFeatures4Col } from "./layouts/ParagraphFeatures4Col";
import { ParagraphHeroProduct } from "./layouts/ParagraphHeroProduct";
import { ParagraphClientLogos } from "./layouts/ParagraphClientLogos";
import { ParagraphDarkTextMiniCards } from "./layouts/ParagraphDarkTextMiniCards";
import { ParagraphLightFeatures2x2 } from "./layouts/ParagraphLightFeatures2x2";
import { ParagraphTealSplitCta } from "./layouts/ParagraphTealSplitCta";
import { ParagraphSplitTextStickyCta } from "./layouts/ParagraphSplitTextStickyCta";
import { ParagraphAudienceMatch } from "./layouts/ParagraphAudienceMatch";
import { ParagraphStoryCard } from "./layouts/ParagraphStoryCard";
import { ParagraphLightCtaBanner } from "./layouts/ParagraphLightCtaBanner";
import { ParagraphTimelineSteps } from "./layouts/ParagraphTimelineSteps";
import { ParagraphTwoModelsCompare } from "./layouts/ParagraphTwoModelsCompare";
import { ParagraphInfoNotice } from "./layouts/ParagraphInfoNotice";
import { ParagraphMetricsChecklistImage } from "./layouts/ParagraphMetricsChecklistImage";
import { ParagraphBenefitsTools } from "./layouts/ParagraphBenefitsTools";
import { ParagraphRealizationsTestimonials } from "./layouts/ParagraphRealizationsTestimonials";
import { ParagraphFaq } from "./layouts/ParagraphFaq";
import { ParagraphBlogLatest } from "./layouts/ParagraphBlogLatest";
import { ParagraphRelatedCatalogs } from "./layouts/ParagraphRelatedCatalogs";
import { ParagraphAnnouncementBar } from "./layouts/ParagraphAnnouncementBar";
import { ParagraphDarkHeroBack } from "./layouts/ParagraphDarkHeroBack";
import styles from "./Paragraph.module.css";

/**
 * **Dynamic import dla layoutów ze Swiper'em** — ParagraphPresentation (layout 7)
 * i ParagraphTwoColsTextPresentation (layout 24) importują `swiper/react` +
 * 3 moduły + `yet-another-react-lightbox` (~50-80 KB JS gzipped + 3 osobne CSS
 * chunki). Powodowało:
 *   - "Reduce unused JavaScript" — kod ładowany na każdej stronie nawet gdy
 *     żaden akapit nie ma layoutu 7/24
 *   - "Forced reflow" — Swiper mierzy container przez offsetWidth/offsetHeight
 *     przy mount, 170 ms blocking
 *
 * `dynamic()` w server component (Paragraph dispatcher) split'uje chunk —
 * Swiper bundle ładuje się TYLKO gdy strona faktycznie ma taki layout, i
 * to po main bundle (poza krytyczną ścieżką LCP/TBT). `ssr: true` (default)
 * — SSR markup z slidów/galerii zachowany (SEO content widoczny).
 *
 * Per Next.js 16 docs: `dynamic()` w server component może lazy-loadować
 * client component bez `ssr: false`. To wystarczy żeby chunk split działał.
 */
const ParagraphPresentation = dynamic(() =>
  import("./layouts/ParagraphPresentation").then((m) => ({
    default: m.ParagraphPresentation,
  })),
);
const ParagraphTwoColsTextPresentation = dynamic(() =>
  import("./layouts/ParagraphTwoColsTextPresentation").then((m) => ({
    default: m.ParagraphTwoColsTextPresentation,
  })),
);
//Gallery slider (49) - Swiper w środku, dynamic bundle split (analog do Presentation).
const ParagraphGallerySlider = dynamic(() =>
  import("./layouts/ParagraphGallerySlider").then((m) => ({
    default: m.ParagraphGallerySlider,
  })),
);
//Product variants selector (54) - client component z useState + animacje CSS,
//dynamic bundle split (nie kazda strona ma ten layout).
const ParagraphProductVariantsSelector = dynamic(() =>
  import("./layouts/ParagraphProductVariantsSelector").then((m) => ({
    default: m.ParagraphProductVariantsSelector,
  })),
);

/**
 * Paragraph — dispatcher per `layout` (discriminated union switch).
 *
 * **Exhaustive check:** TypeScript wymusi handler dla każdego variantu w
 * `ParagraphData`. Gdy backend doda nowy layout -> typ wymusi update.
 *
 * **Reusable z dowolnego komponentu** — używany przez `<ParagraphRenderer>`
 * dla listy akapitów, ale można też wywołać bezpośrednio dla pojedynczego
 * akapitu z innego komponentu CMS / okna / panelu admina.
 *
 * Nieznane layouty -> placeholder dev hint (informacyjny, nie wybucha — pozwala
 * dodać nowy layout backend-first bez awarii istniejących stron).
 */
export function Paragraph({
  paragraph,
  t,
}: {
  paragraph: ParagraphData;
  t: ParagraphTranslations;
}) {
  switch (paragraph.layout) {
    case PARAGRAPH_TEXT_LAYOUT:
      return <ParagraphText paragraph={paragraph} t={t} />;

    case PARAGRAPH_TEXT_IMAGES_LEFT_LAYOUT:
    case PARAGRAPH_TEXT_IMAGES_RIGHT_LAYOUT:
    case PARAGRAPH_TEXT_IMAGES_TOP_LAYOUT:
    case PARAGRAPH_TEXT_IMAGES_BOT_LAYOUT:
    case PARAGRAPH_TWO_COLS_TEXT_GALLERY_LAYOUT:
      return <ParagraphTextImages paragraph={paragraph} t={t} />;

    case PARAGRAPH_TWO_COLS_TEXT_LAYOUT:
      return <ParagraphTwoColsText paragraph={paragraph} t={t} />;

    case PARAGRAPH_TWO_COLS_TEXT_VIDEO_LAYOUT:
      return <ParagraphTwoColsTextVideo paragraph={paragraph} t={t} />;

    case PARAGRAPH_TWO_COLS_TABLE_TEXT_LAYOUT:
      return <ParagraphTwoColsTableText paragraph={paragraph} t={t} />;

    case PARAGRAPH_PREZENTATION_LAYOUT:
      return <ParagraphPresentation paragraph={paragraph} t={t} />;

    case PARAGRAPH_BIG_PHOTO_LAYOUT:
      return <ParagraphBigPhoto paragraph={paragraph} t={t} />;

    case PARAGRAPH_THREE_COLS_TEXT_LAYOUT:
      return <ParagraphThreeColsText paragraph={paragraph} t={t} />;

    case PARAGRAPH_THREE_COLS_TEXT_TEXT_PHOTO_LAYOUT:
    case PARAGRAPH_THREE_COLS_TEXT_PHOTO_TEXT_LAYOUT:
    case PARAGRAPH_THREE_COLS_PHOTO_TEXT_TEXT_LAYOUT:
      return <ParagraphThreeColsTextImages paragraph={paragraph} t={t} />;

    case PARAGRAPH_THREE_COLS_BIG_VIDEO_LAYOUT:
      return <ParagraphBigVideo paragraph={paragraph} t={t} />;

    case PARAGRAPH_TWO_BOXES_LAYOUT:
      return <ParagraphTwoBoxes paragraph={paragraph} t={t} />;

    case PARAGRAPH_THREE_BOXES_LAYOUT:
      return <ParagraphThreeBoxes paragraph={paragraph} t={t} />;

    case PARAGRAPH_CONTACT_FORM_LAYOUT:
      return <ParagraphContactForm paragraph={paragraph} t={t} />;

    case PARAGRAPH_MAPS_LAYOUT:
      return <ParagraphMaps paragraph={paragraph} t={t} />;

    case PARAGRAPH_TWO_COLS_TEXT_PREZENTATION_LAYOUT:
      return <ParagraphTwoColsTextPresentation paragraph={paragraph} t={t} />;

    case PARAGRAPH_BLOG_POSTS_LAYOUT:
      return <ParagraphBlogPosts paragraph={paragraph} t={t} />;

    case PARAGRAPH_CONTACT_PERSON_LAYOUT:
      return <ParagraphContactPerson paragraph={paragraph} t={t} />;

    case PARAGRAPH_HERO_CTA_LAYOUT:
      return <ParagraphHeroCta paragraph={paragraph} t={t} />;

    case PARAGRAPH_PROCESS_STEPS_LAYOUT:
      return <ParagraphProcessSteps paragraph={paragraph} t={t} />;

    case PARAGRAPH_CTA_BANNER_LAYOUT:
      return <ParagraphCtaBanner paragraph={paragraph} t={t} />;

    case PARAGRAPH_PRODUCT_CTA_LAYOUT:
      return <ParagraphProductCta paragraph={paragraph} t={t} />;

    case PARAGRAPH_FEATURES_ICONS_LAYOUT:
      return <ParagraphFeaturesIcons paragraph={paragraph} t={t} />;

    case PARAGRAPH_TEXT_STATS_LAYOUT:
      return <ParagraphTextStats paragraph={paragraph} t={t} />;

    case PARAGRAPH_TECH_STACK_LAYOUT:
      return <ParagraphTechStack paragraph={paragraph} t={t} />;

    case PARAGRAPH_SERVICE_HERO_LAYOUT:
      return <ParagraphServiceHero paragraph={paragraph} t={t} />;

    case PARAGRAPH_WHY_US_LAYOUT:
      return <ParagraphWhyUs paragraph={paragraph} t={t} />;

    case PARAGRAPH_FEATURES_2COL_LAYOUT:
      return <ParagraphFeatures2Col paragraph={paragraph} t={t} />;

    case PARAGRAPH_PRICING_TIERS_LAYOUT:
      return <ParagraphPricingTiers paragraph={paragraph} t={t} />;

    case PARAGRAPH_INTEGRATIONS_GRID_LAYOUT:
      return <ParagraphIntegrationsGrid paragraph={paragraph} t={t} />;

    case PARAGRAPH_TWO_PATHS_LAYOUT:
      return <ParagraphTwoPaths paragraph={paragraph} t={t} />;

    case PARAGRAPH_DARK_FEATURES_LAYOUT:
      return <ParagraphDarkFeatures paragraph={paragraph} t={t} />;

    case PARAGRAPH_SERVICES_LAYOUT:
      return <ParagraphServices paragraph={paragraph} t={t} />;

    case PARAGRAPH_TEXT_MINI_CARDS_LAYOUT:
      return <ParagraphTextMiniCards paragraph={paragraph} t={t} />;

    case PARAGRAPH_DARK_HERO_CTA_LAYOUT:
      return <ParagraphDarkHeroCta paragraph={paragraph} t={t} />;

    case PARAGRAPH_FEATURES_4COL_LAYOUT:
      return <ParagraphFeatures4Col paragraph={paragraph} t={t} />;

    case PARAGRAPH_GALLERY_SLIDER_LAYOUT:
      return <ParagraphGallerySlider paragraph={paragraph} t={t} />;

    case PARAGRAPH_HERO_PRODUCT_LAYOUT:
      return <ParagraphHeroProduct paragraph={paragraph} t={t} />;

    case PARAGRAPH_DARK_TEXT_MINI_CARDS_LAYOUT:
      return <ParagraphDarkTextMiniCards paragraph={paragraph} t={t} />;

    case PARAGRAPH_LIGHT_FEATURES_2X2_LAYOUT:
      return <ParagraphLightFeatures2x2 paragraph={paragraph} t={t} />;

    case PARAGRAPH_TEAL_SPLIT_CTA_LAYOUT:
      return <ParagraphTealSplitCta paragraph={paragraph} t={t} />;

    case PARAGRAPH_PRODUCT_VARIANTS_SELECTOR_LAYOUT:
      return <ParagraphProductVariantsSelector paragraph={paragraph} t={t} />;

    case PARAGRAPH_CLIENT_LOGOS_LAYOUT:
      return <ParagraphClientLogos paragraph={paragraph} t={t} />;

    case PARAGRAPH_SPLIT_TEXT_STICKY_CTA_LAYOUT:
      return <ParagraphSplitTextStickyCta paragraph={paragraph} t={t} />;

    case PARAGRAPH_AUDIENCE_MATCH_LAYOUT:
      return <ParagraphAudienceMatch paragraph={paragraph} t={t} />;

    case PARAGRAPH_STORY_CARD_LAYOUT:
      return <ParagraphStoryCard paragraph={paragraph} t={t} />;

    case PARAGRAPH_LIGHT_CTA_BANNER_LAYOUT:
      return <ParagraphLightCtaBanner paragraph={paragraph} t={t} />;

    case PARAGRAPH_TIMELINE_STEPS_LAYOUT:
      return <ParagraphTimelineSteps paragraph={paragraph} t={t} />;

    case PARAGRAPH_TWO_MODELS_COMPARE_LAYOUT:
      return <ParagraphTwoModelsCompare paragraph={paragraph} t={t} />;

    case PARAGRAPH_INFO_NOTICE_LAYOUT:
      return <ParagraphInfoNotice paragraph={paragraph} t={t} />;

    case PARAGRAPH_METRICS_CHECKLIST_IMAGE_LAYOUT:
      return <ParagraphMetricsChecklistImage paragraph={paragraph} t={t} />;

    case PARAGRAPH_BENEFITS_TOOLS_LAYOUT:
      return <ParagraphBenefitsTools paragraph={paragraph} t={t} />;

    case PARAGRAPH_REALIZATIONS_TESTIMONIALS_LAYOUT:
      return <ParagraphRealizationsTestimonials paragraph={paragraph} t={t} />;

    case PARAGRAPH_FAQ_LAYOUT:
      return <ParagraphFaq paragraph={paragraph} t={t} />;

    case PARAGRAPH_BLOG_LATEST_LAYOUT:
      return <ParagraphBlogLatest paragraph={paragraph} t={t} />;

    case PARAGRAPH_RELATED_CATALOGS_LAYOUT:
      return <ParagraphRelatedCatalogs paragraph={paragraph} t={t} />;

    case PARAGRAPH_ANNOUNCEMENT_BAR_LAYOUT:
      return <ParagraphAnnouncementBar paragraph={paragraph} t={t} />;

    case PARAGRAPH_DARK_HERO_BACK_LAYOUT:
      return <ParagraphDarkHeroBack paragraph={paragraph} t={t} />;

    default:
      return <UnsupportedParagraph paragraph={paragraph} t={t} />;
  }
}

/**
 * UnsupportedParagraph — placeholder dla layoutów których renderer nie zna.
 *
 * Renderowany gdy backend zwrócił `layout` spoza znanych enumów (np. nowy
 * layout dodany w PHP `define.php` ale jeszcze nie odzwierciedlony w React-CMS).
 * Pokazuje dev hint zamiast wybuchać.
 */
function UnsupportedParagraph({
  paragraph,
  t,
}: {
  paragraph: { layout?: number | string };
  t: ParagraphTranslations;
}) {
  const layoutNum =
    typeof paragraph.layout === "number"
      ? paragraph.layout
      : parseInt(String(paragraph.layout ?? "0"), 10) || 0;
  return (
    <section className={styles.paragraph}>
      <div className={styles.paragraphUnsupported}>
        <strong>{t.unsupportedLayout(layoutNum)}</strong> {t.unsupportedLayoutBody}
      </div>
    </section>
  );
}
